"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useMenuWithLinksItemContainer = function (handleClose, onClickFns) {
    var handleClickFn = react_1.useCallback(function (i) {
        return function () {
            handleClose();
            if (onClickFns[i]) {
                onClickFns[i]();
            }
        };
    }, [onClickFns, handleClose]);
    return ({
        handleClickFn: handleClickFn,
    });
};
exports.default = useMenuWithLinksItemContainer;
